import { graphql } from "~/gql";

export const UPLIFT_FRAGMENT = graphql(/* GraphQL */ `
  fragment UpliftParts on Uplift {
    __typename
    autoFocus @client
    id
    amount
    type
    order
    baseUplift {
      id
      reason
    }
    includeOnProposal
  }
`);
